import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";
import BSZRoomAvailability from "./BSZRoomAvailability";

export default function AddRoomDialog({ open, onClose, onSave, initialData }) {
  const isEditMode = Boolean(initialData);

  /**
   * =========================================================
   * ✅ STATE
   * =========================================================
   */
  const [name, setName] = useState("");
  const [studentSlots, setStudentSlots] = useState(25);
  const [teacherSlots, setTeacherSlots] = useState(1);
  const [availability, setAvailability] = useState([]);
  const [error, setError] = useState("");

  /**
   * =========================================================
   * ✅ INIT / RESET
   * =========================================================
   */
  useEffect(() => {
    if (!open) return;

    if (initialData) {
      setName(initialData.name || "");

      setStudentSlots(initialData.studentSlots?.length ?? 20);

      setTeacherSlots(initialData.teacherSlots?.length ?? 1);

      setAvailability(initialData.availability || []);
    } else {
      setName("");
      setStudentSlots(20);
      setTeacherSlots(1);
      setAvailability([]);
    }

    setError("");
  }, [open, initialData]);

  /**
   * =========================================================
   * ✅ SAVE
   * =========================================================
   */
  const handleSave = async () => {
    if (!name.trim()) {
      setError("Bitte Namen angeben.");
      return;
    }

    try {
      setError("");

      await onSave({
        id: initialData?.id,

        name: name.trim(),

        studentSlots: Number(studentSlots),
        teacherSlots: Number(teacherSlots),

        availability,
      });

      onClose();
    } catch (err) {
      console.error(err);

      setError("Fehler beim Speichern des Raums.");
    }
  };

  // console.log("name:", name, " ID: ", initialData?.id);
  // console.log("studentSlots:", studentSlots);
  // console.log("teacherSlots:", teacherSlots);
  // console.log("availability:", availability);

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {isEditMode ? "Raum bearbeiten" : "Neuen Raum erstellen"}
      </DialogTitle>

      <DialogContent>
        {error && (
          <Typography
            sx={{
              color: "error.main",
              mb: 2,
            }}
          >
            {error}
          </Typography>
        )}

        {/* =====================================================
            BASIC DATA
        ====================================================== */}
        <Stack spacing={2} mt={1}>
          <TextField
            label="Raumname"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
          />

          <TextField
            label="Anzahl Schüler-Slots"
            type="number"
            value={studentSlots}
            onChange={(e) => setStudentSlots(e.target.value)}
          />

          <TextField
            label="Anzahl Lehrer-Slots"
            type="number"
            value={teacherSlots}
            onChange={(e) => setTeacherSlots(e.target.value)}
          />
        </Stack>

        {/* =====================================================
            AVAILABILITY
        ====================================================== */}
        <BSZRoomAvailability
          availability={availability}
          onChange={setAvailability}
        />
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel={isEditMode ? "Speichern" : "Erstellen"}
      />
    </Dialog>
  );
}
